import ContactGetter from "../../Components/ContactGetter/ContactGetter";
import ContactGroupDetail from "../../Components/ContactGroupDetail/ContactGroupDetail";
import "../../Styles/App.css";

function ContactsListPage() {
  return (
    <>
      <ContactGroupDetail />
      <ContactGetter />
    </>
  );
}

export default ContactsListPage;
